<template>
    <div class="bg-main-color w-full mb-5 overflow-visible">
        <div class="flex  md:justify-end xl:justify-end">
            <div class="container mx-auto flex justify-between items-center">
                <div class="overflow-visible">
                    <a
  v-if="$store.catalog?.file"
  :href="$store.catalog.file"
  target="_blank"
  download
  @click="$store.downloadCatalog()"
  class="relative inline-flex items-center justify-center gap-1 py-2 text-white hover:text-accent-color group overflow-visible"
>
  {{ $t('page.catalog') }}
  <span class="text-sm">({{ $store.catalog?.download_count || 0 }})</span>
  <IconDownload class="[&>path]:fill-white group-hover:[&>path]:fill-accent-color" />

  <span
    v-if="$store.catalog?.has_catalog"
    class="absolute top-0.5 left-0 -translate-x-[100%] h-2.5 w-2.5 rounded-full bg-red-500 z-10"
  />
</a>

<!-- если файла нет — просто текст без ссылки -->
<span v-else class="relative inline-flex items-center gap-1 py-2 text-white/70">
  {{ $t('page.catalog') }}
  <span class="text-sm">(0)</span>
</span>
                </div>
                <div class="text-sm md:text-base text-accent-gray-color flex gap-5 md:gap-12.5 h-10">

                    <RouterLink class="flex items-center gap-1.5 relative" :to="{ name: 'publicationHome' }"
                        :class="{'text-white font-bold' : currentRoute === 'publication'}">
                        <p>{{ $t('nav.publications') }}</p>
                        <span class="absolute top-0 -right-5 bg-red-color text-white w-5 h-5 rounded-full text-center leading-5 text-[13px]" v-if="getLastSeenPublicationsCount">{{ getLastSeenPublicationsCount  }}</span>
                    </RouterLink>

                    <RouterLink class="flex items-center gap-1.5 relative" :to="{ name: 'foodHomePage' }"
                        :class="{'text-white font-bold' : currentRoute === 'food'}">
                    <p>{{ $t('nav.food') }}</p>
                        <span class="absolute top-0 -right-5 bg-red-color text-white w-5 h-5 rounded-full text-center leading-5 text-[13px]" v-if="getLastSeenExhibitionCount">{{ getLastSeenExhibitionCount }}</span>
                    </RouterLink>

                    <RouterLink class="flex items-center gap-1.5 relative" :to="{ name: 'mallHome' }"
                        :class="{'text-white font-bold' : currentRoute === 'mall'}">
                    <p>{{ $t('nav.mall') }}</p>
                        <span class="absolute top-0 -right-5 bg-red-color text-white w-5 h-5 rounded-full text-center leading-5 text-[13px]" v-if="getLastSeenMallCount">{{ getLastSeenMallCount }}</span>
                    </RouterLink>

                    <RouterLink v-if="HABARLAR_ENABLED" class="flex items-center gap-1.5 relative" :to="{ name: 'news' }"
                        :class="{'text-white font-bold' : currentRoute === 'news'}">
                        <p>{{ $t('nav.news') }}</p>
                        <span class="absolute top-0 -right-5 bg-red-color text-white w-5 h-5 rounded-full text-center leading-5 text-[13px]" v-if="getLastSeenMediaCount">{{ getLastSeenMediaCount }}</span>
                    </RouterLink>

                    <RouterLink class="flex items-center gap-1.5 relative" :to="{ name: 'mediaHome' }"
                        :class="{'text-white font-bold' : currentRoute === 'media'}">
                        <p>{{ $t('nav.media') }}</p>
                        <span class="absolute top-0 -right-5 bg-red-color text-white w-5 h-5 rounded-full text-center leading-5 text-[13px]" v-if="mediaBadgeCount">{{ mediaBadgeCount }}</span>
                    </RouterLink>
                    <RouterLink class="flex items-center gap-1.5 relative" :to="{ name: 'businessAccounts' }"
                        :class="{'text-white font-bold' : currentRoute === 'business'}">
                        <p>{{ $t('nav.businessAccounts') }}</p>
                        <span class="absolute top-0 -right-5 bg-red-color text-white w-5 h-5 rounded-full text-center leading-5 text-[13px]" v-if="getLastSeenBusinessAccountsCount">{{ getLastSeenBusinessAccountsCount }}</span>
                    </RouterLink>
                    <LanguageSwitcher/>
                    <!-- <div class="text-xs md:text-[13px]">
                        <select v-model="selectedLanguage" @change="changeLanguage"
                            class="cursor-pointer bg-main-color text-main-gray-color h-10 px-2">
                            <option value="tk">TM</option>
                            <option value="RU">RU</option>
                        </select>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>




<script>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import IconDownload from '@icons/IconDownload.vue';
import { mapState } from 'pinia'
import { useAppStore } from '@/store'
import { FEATURE_FLAGS } from '@/constants'
export default {
    name: 'TopHeader',
    components: {
        LanguageSwitcher,
        IconDownload
    },
    watch: {
        '$route.path': {
            //   immediate: true,
            handler(newValue, oldValue) {
                if (newValue !== oldValue){
                    
                    if (newValue.includes('mall')){
                        this.currentRoute = 'mall'
                    }
                    else if (newValue.includes('business')){
                        this.currentRoute = 'business'
                    }
                    else if (newValue.includes('news')){
                        this.currentRoute = 'news'
                    }
                    else if (newValue.includes('media')){
                        this.currentRoute = 'media'
                    }
                    else if (newValue.includes('profile')){
                        this.currentRoute = 'profile'
                    }
                    else if (newValue.includes('food')){
                        this.currentRoute = 'food'
                    }

                    else {
                        this.currentRoute = 'publication'
                    }
                }
                
            },
            immediate: true,
        },
    },
    data() {
        return {
            currentRoute: '',
            HABARLAR_ENABLED: FEATURE_FLAGS.HABARLAR,
		}	         
        
    },
    computed: {
        ...mapState(useAppStore, ['getLastSeen', 'getLastSeenPublicationsCount', 'getLastSeenMallCount', 'getLastSeenExhibitionCount', 'getLastSeenMediaCount', 'getLastSeenVideosCount', 'getLastSeenBusinessAccountsCount']),
        mediaBadgeCount() {
            return this.HABARLAR_ENABLED ? this.getLastSeenMediaCount : this.getLastSeenVideosCount
        },
       
    },
    methods: {
     

    }

}
</script>


<style scoped>
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    text-align: center;
    font-weight: 600;
    word-wrap: break-word;
    border-left: 1px solid #b2b2b2;
    border-right: 1px solid #b2b2b2;
    height: 100%;
}

select:focus {
    outline: none;
}

.active {
    color: #F2F2F2;
    font-weight: bold;
}

.activeHabarlar {
    color: #F2F2F2;
    font-weight: bold;
}

.activeHome {
    color: #F2F2F2;
    font-weight: bold;
}

</style>